/*eslint-disable */
import axios from "axios"
import { queryFixer } from "common/utils/utils"

const PedidoService = {
  async getEdiFromPedido(id: $TSMigrationFixMe, formato: $TSMigrationFixMe) {
    // @ts-expect-error TS(2554): Expected 1-2 arguments, but got 3.
    return axios.get(`/Pedido/export-edi/${id}/formato/${formato}`, null, {
      responseType: "blob",
    })
  },

  async importarEDI(file: $TSMigrationFixMe) {
    return axios.post("/Pedido/import-edi", file)
  },

  getArchivosAdjuntosById(id: $TSMigrationFixMe) {
    return axios.get(`/Pedido/${id}/ficheros-adjuntos`)
  },

  getDocumentosAsociadosById(id: $TSMigrationFixMe) {
    return axios.get(`/Pedido/${id}/documentos-asociados`)
  },

  addNewArchivoAdjunto(pedidoID: $TSMigrationFixMe, file: $TSMigrationFixMe) {
    return axios.post(`/Pedido/${pedidoID}/add-fichero-adjunto`, file)
  },

  deleteArchivoAdjunto(pedidoID: $TSMigrationFixMe, fileID: $TSMigrationFixMe) {
    return axios.delete(`/Pedido/${pedidoID}/fichero/${fileID}`)
  },

  getById(id: $TSMigrationFixMe) {
    return axios.get(`/Pedido/${id}`)
  },

  archivosGetById(id: $TSMigrationFixMe) {
    return axios.get(`/Pedido/${id}/ficheros-adjuntos`)
  },

  getPdfById(id: $TSMigrationFixMe) {
    return axios.get(`/Pedido/${id}/pdf`, {
      responseType: "blob",
    })
  },

  getPedidosWithSameLibradoLibrador({
    libradoId,
    libradorId,
    ...filters
  }: $TSMigrationFixMe) {
    return axios.get("/Pedido/by-filters", {
      params: {
        ...filters,
        libradoId,
        libradorId,
      },
    })
  },

  getPedidosEnviados({ libradorId, queryState }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Pedido/by-filters?libradorId=${libradorId}`,
      queryState
    )
    return axios.get(query)
  },
  getPedidoByMsgEncrypted({ msgEncrypted }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Pedido/by-filters-encrypted?MsgEncrypted=${msgEncrypted}`
    )
    return axios.get(query)
  },
  getPedidosRecibidos({ libradoId, queryState }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Pedido/by-filters?libradoId=${libradoId}`,
      queryState
    )
    return axios.get(query)
  },

  changeEstado({
    documentoId,
    estadoRevisionDocumento,
    motivo,
  }: $TSMigrationFixMe) {
    return axios.put("/Pedido/change-estado", {
      documentoId,
      estadoRevisionDocumento,
      motivo: motivo?.length ? motivo : null,
    })
  },

  changeMultipleEstados({
    documentosId = [],
    estadoRevisionDocumento,
    motivo,
  }: $TSMigrationFixMe) {
    return axios.put("/Pedido/bulk-change-estado", {
      documentosId,
      estadoRevisionDocumento,
      motivo: motivo?.length ? motivo : null,
    })
  },
  getDocumentosPendientesValidar(queryParam: $TSMigrationFixMe) {
    return axios.get(`/pedido/pendientes-firmar${queryParam}`)
  },
  getDocumentoPendienteValidacion(id: $TSMigrationFixMe) {
    return axios.get(`/pedido/${id}/validacion`)
  },
  validateDocumentoPendiente(id: $TSMigrationFixMe, data: $TSMigrationFixMe) {
    return axios.post(`/pedido/${id}/aprobacion`, data)
  },
}

export default PedidoService
